/* eslint-disable import/prefer-default-export */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var ClockIcon = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "white",
                strokeWidth: "2",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "11.75",
                y1: "13",
                x2: "11.75",
                y2: "7",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "11.5",
                y1: "12.5",
                x2: "16.5",
                y2: "16.5",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};
export { ClockIcon };
